import React from "react";
import T from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import {
  translateProps,
  toggleSwitch,
  renderIf
} from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon, ConfirmAction } from "MODULES/shared/components";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import withPurchaseOrder from "MODULES/PurchaseOrders/decorators/withPurchaseOrder";

export function ReverseExchange({ outright, convertToOutright, open, close }) {
  return (
    <DropDownItem onClick={open}>
      <Icon name="shopping-cart" fixed />
      <span className="with-padding">Convert to Outright</span>
      <ConfirmAction
        onConfirm={() => outright()}
        close={close}
        open={convertToOutright}
      />
    </DropDownItem>
  );
}

ReverseExchange.propTypes = {
  outright: T.func.isRequired,
  creatingOutright: T.bool.isRequired,
  confirmConfig: T.shape({}).isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  ...WithCurrentUser
};

const withExchange = translateProps(
  ({
    lineItem: { id: itemId, purchase_order_id: purchaseOrderId },
    close,
    pushHistory
  }) => ({
    outright: () =>
      api.purchaseOrders.lineItems.exchangeReversal(itemId).then(() => {
        pushHistory({ pathname: `/purchase-orders/${purchaseOrderId}` });
        close();
      })
  })
);

const meetsExchangeReversalCriteria = renderIf(
  ({ lineItem }) =>
    !lineItem.cancelled &&
    !lineItem.shipped &&
    !lineItem.received &&
    lineItem.purchase_for_exchange
);

export const exchange = withPurchaseOrder(
  toggleSwitch("convertToOutright")(
    withCurrentUser(
      meetsExchangeReversalCriteria(withExchange(ReverseExchange))
    )
  )
);

export default connect(undefined, { pushHistory: push })(exchange);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/ReverseExchange/ReverseExchange.jsx